import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from '@mui/material';

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(0),
}));

export const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  '&.MuiButtonBase-root': {
    padding: theme.spacing(1, 0),
  },
  '&.Mui-disabled': {
    opacity: 1,
  },
}));

export const ListItemIconStyled = styled(ListItemIcon)({
  minWidth: 0,
  alignItems: 'center',
});
export const ListItemTextStyled = styled(ListItemText)({
  margin: 0,
});
